import {
  ArrowLeftIcon,
  ArrowRightIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
} from '@chakra-ui/icons';
import React from 'react';

import { LIMIT_PER_PAGE } from '@/domain/models/Pagination';

import { CmFlex, CmIconButton, CmText, CmTooltip } from '..';

interface Props {
  totalNum: number;
  currentPage: number;
  toFirstPage: () => void;
  toLastPage: () => void;
  toNextPage: () => void;
  toPreviousPage: () => void;
}

export const CmPagination: React.VFC<Props> = ({
  totalNum,
  currentPage,
  toFirstPage,
  toLastPage,
  toNextPage,
  toPreviousPage,
}) => {
  const isFirstPage = currentPage === 1;
  const totalPage = Math.ceil(totalNum / LIMIT_PER_PAGE);
  const isLastPage = currentPage === totalPage;

  return (
    <CmFlex justifyContent="space-between" mt={4} alignItems="center">
      <CmFlex>
        <CmTooltip label="First Page">
          {/*
           // @ts-ignore TS2590 */}
          <CmIconButton
            onClick={toFirstPage}
            isDisabled={isFirstPage}
            icon={<ArrowLeftIcon h={3} w={3} />}
            mr={4}
            aria-label="First Page"
          />
        </CmTooltip>
        <CmTooltip label="Previous Page">
          <CmIconButton
            onClick={toPreviousPage}
            isDisabled={isFirstPage}
            icon={<ChevronLeftIcon h={6} w={6} />}
            aria-label="Previous Page"
          />
        </CmTooltip>
      </CmFlex>

      <CmFlex alignItems="center">
        <CmText mr={8}>
          <CmText fontWeight="bold" as="span" mr={2}>
            {currentPage}
          </CmText>{' '}
          /{' '}
          <CmText fontWeight="bold" as="span" ml={2}>
            {totalPage}
          </CmText>
        </CmText>
      </CmFlex>

      <CmFlex>
        <CmTooltip label="Next Page">
          <CmIconButton
            onClick={toNextPage}
            isDisabled={isLastPage}
            icon={<ChevronRightIcon h={6} w={6} />}
            aria-label="Next Page"
          />
        </CmTooltip>
        <CmTooltip label="Last Page">
          <CmIconButton
            onClick={toLastPage}
            isDisabled={isLastPage}
            icon={<ArrowRightIcon h={3} w={3} />}
            ml={4}
            aria-label="Last Page"
          />
        </CmTooltip>
      </CmFlex>
    </CmFlex>
  );
};
